import { BaseModel } from '@Core';

export interface CameraNotes extends BaseModel {
    Notes: string;
    CameraId: number;
    Type: CameraNoteType;
    ExemptVehicleTypes?: ExemptVehicleType[];
}

export enum CameraNoteType {
    Verification,
    Camera,
}

export enum ExemptVehicleType {
    Bus = 'bus',
    Hgv = 'hgv',
    Truck = 'truck',
    Van = 'van',
}
